import { TTableBorderCell } from './Table.type';

export const TABLE_BORDER_CELLS: TTableBorderCell[] = ['none', 'column', 'row', 'both']
export const TABLE_BORDER_CELL: { [key in TTableBorderCell]: key } = {
	none: 'none',
	column: 'column',
	row: 'row',
	both: 'both',
}

export const TABLE_DEFAULT_PROPS = {
	borderCell: TABLE_BORDER_CELL.column,
}
